import { PreviewComponentProps } from "@camberi/firecms";
import { ReactElement } from "react";

export default function CustomIllustrationsPreview({ value, property, size }: PreviewComponentProps<string[]>): ReactElement {
  return <span>{value.length}</span>
}
